import { useMutation } from '@tanstack/react-query';

import { MutationFunction, useRequest } from '@frontend/api';
import { useOptimisticMutationCallbacks } from '@frontend/api';

import type { OrderByNumberParams, Order } from './types';
import { getOrderByNumberQueryKey } from './utils';

export type UpdatePrivateNotesQueryKeyType = readonly [
  'orderByNumber',
  'updatePrivateNotes',
  string,
  string,
];

export const updatePrivateNotesQueryKey = (
  params: OrderByNumberParams,
): UpdatePrivateNotesQueryKeyType => [
  'orderByNumber',
  'updatePrivateNotes',
  params.groupId,
  params.orderNumber,
];

export const useUpdatePrivateNotes: MutationFunction<
  Order,
  string,
  [OrderByNumberParams]
> = (params, { query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const { groupId, orderNumber } = params;
  const url = `/orders/by_number/${orderNumber}/private_notes?group=${groupId}`;
  const key = getOrderByNumberQueryKey(params);
  const mutationKey = updatePrivateNotesQueryKey(params);
  const optimisticMutationCallbacks = useOptimisticMutationCallbacks({
    key,
    queryOptions,
  });

  return useMutation(
    (text) =>
      request(url, {
        query,
        init: {
          method: 'POST',
          body: { text },
        },
      }),
    {
      ...queryOptions,
      ...optimisticMutationCallbacks,
      mutationKey,
    },
  );
};
